(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-v1"] && !Shopify.designMode) return;
  try {
    
$('.js_section_product').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 1024, // Tablet and below
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767, // Mobile and below
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-slideshow-v2"] && !Shopify.designMode) return;
  try {
    
  /* Optional: initialize slick if not already initialized elsewhere */
  (function() {
    var $el = (typeof jQuery !== 'undefined') ? jQuery('.js-slideshow-v2') : null;
    if ($el && $el.length && typeof $el.slick === 'function' && !$el.hasClass('slick-initialized')) {
      $el.slick({
        dots: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        adaptiveHeight: true
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
